import { openBlock, createElementBlock, normalizeClass, toDisplayString, createCommentVNode, createElementVNode, Fragment, renderList, createTextVNode, renderSlot, createBlock, Transition, withCtx, normalizeStyle } from 'vue';
import _ from 'lodash';

var script$d = {
  name: 'LsnCheckboxBox',
  props: {
    modelValue: {
      type: Array,
      default: function () {
        return [];
      }
    },
    label: {
      type: String,
      default: null
    },
    options: {
      type: Array,
      required: true
    },
    ovalue: {
      type: String,
      default: 'id'
    },
    olabel: {
      type: String,
      default: 'label'
    },
    error: {
      type: [String, Array],
      default: null
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      selection: this.modelValue
    };
  },
  computed: {
    errMsg() {
      return Array.isArray(this.error) ? this.error[0] : this.error;
    }
  },
  watch: {
    selection(newSelection) {
      this.$emit('update:modelValue', newSelection);
    }
  },
  methods: {
    toggleValue(val) {
      let index = this.selection.indexOf(val);
      if (index === -1) {
        this.selection.push(val);
      } else {
        this.selection.splice(index, 1);
      }
    }
  }
};

const _hoisted_1$b = {
  key: 0,
  class: "lsn-form__label"
};
const _hoisted_2$b = {
  class: "lsn-form__radio-item-wrapper"
};
const _hoisted_3$9 = ["onClick"];
const _hoisted_4$6 = {
  key: 1,
  class: "lsn-form__error"
};
function render$d(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["lsn-form__wrapper", {
      'lsn-form__wrapper--error': $props.error
    }])
  }, [$props.label ? (openBlock(), createElementBlock("label", _hoisted_1$b, toDisplayString($props.label), 1)) : createCommentVNode("", true), createElementVNode("div", _hoisted_2$b, [(openBlock(true), createElementBlock(Fragment, null, renderList($props.options, option => {
    return openBlock(), createElementBlock("div", {
      key: option[$props.ovalue],
      class: normalizeClass(["lsn-form__radio-item", {
        'lsn-form__radio-item--selected': $props.modelValue.indexOf(option[$props.ovalue]) !== -1
      }]),
      onClick: $event => $options.toggleValue(option[$props.ovalue])
    }, toDisplayString(option[$props.olabel]), 11, _hoisted_3$9);
  }), 128))]), $props.error ? (openBlock(), createElementBlock("div", _hoisted_4$6, toDisplayString($options.errMsg), 1)) : createCommentVNode("", true)], 2);
}

script$d.render = render$d;

var script$c = {
  name: 'LsnCheckboxList',
  props: {
    modelValue: {
      type: Array,
      default: function () {
        return [];
      }
    },
    label: {
      type: String,
      default: null
    },
    options: {
      type: Array,
      required: true
    },
    ovalue: {
      type: String,
      default: 'id'
    },
    olabel: {
      type: String,
      default: 'label'
    },
    error: {
      type: [String, Array],
      default: null
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      selection: this.modelValue
    };
  },
  computed: {
    errMsg() {
      return Array.isArray(this.error) ? this.error[0] : this.error;
    }
  },
  watch: {
    selection(newSelection) {
      this.$emit('update:modelValue', newSelection);
    }
  },
  methods: {
    toggleValue(val) {
      let index = this.selection.indexOf(val);
      if (index === -1) {
        this.selection.push(val);
      } else {
        this.selection.splice(index, 1);
      }
    }
  }
};

const _hoisted_1$a = {
  key: 0,
  class: "lsn-form__label"
};
const _hoisted_2$a = {
  class: "lsn-form__checkboxes"
};
const _hoisted_3$8 = ["checked", "onChange"];
const _hoisted_4$5 = {
  key: 1,
  class: "lsn-form__error"
};
function render$c(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["lsn-form__wrapper", {
      'lsn-form__wrapper--error': $props.error
    }])
  }, [$props.label ? (openBlock(), createElementBlock("label", _hoisted_1$a, toDisplayString($props.label), 1)) : createCommentVNode("", true), createElementVNode("div", _hoisted_2$a, [(openBlock(true), createElementBlock(Fragment, null, renderList($props.options, option => {
    return openBlock(), createElementBlock("label", {
      key: option[$props.ovalue],
      class: "lsn-form__checkbox-label"
    }, [createElementVNode("input", {
      type: "checkbox",
      class: "lsn-form__checkbox",
      checked: $props.modelValue.indexOf(option[$props.ovalue]) !== -1,
      onChange: $event => $options.toggleValue(option[$props.ovalue])
    }, null, 40, _hoisted_3$8), createTextVNode(" " + toDisplayString(option[$props.olabel]), 1)]);
  }), 128))]), $props.error ? (openBlock(), createElementBlock("div", _hoisted_4$5, toDisplayString($options.errMsg), 1)) : createCommentVNode("", true)], 2);
}

script$c.render = render$c;

/* =================
 * Lsn Click Outside
 * =================
 */

var LsnClickOutside = {
  beforeMount(el, binding) {
    // Define ourClickEventHandler
    const ourClickEventHandler = event => {
      if (el !== event.target && !el.contains(event.target)) {
        // As we are attaching a click event listener to the document (below),
        // ensure the event target is outside the element.
        binding.value(event); // before binding it
      }
    };

    // Attach the handler to the element so we can remove it later easily
    el.__vueClickEventHandler__ = ourClickEventHandler;

    // Bind ourClickEventHandler to a listener on the document
    document.addEventListener('click', ourClickEventHandler);
  },
  unmounted(el) {
    // Remove Event Listener
    document.removeEventListener('click', el.__vueClickEventHandler__);
  }
};

var script$b = {
  name: 'LsnDataList',
  props: {
    modelValue: {
      type: [String, Number],
      default: null
    },
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    ovalue: {
      type: String,
      default: 'id'
    },
    error: {
      type: [String, Array],
      default: null
    }
  },
  emits: ['update:modelValue'],
  computed: {
    errMsg() {
      return Array.isArray(this.error) ? this.error[0] : this.error;
    }
  },
  methods: {
    optValue(opt) {
      if (!_.isObject(opt)) {
        return opt;
      }
      return _.has(opt, this.ovalue) ? opt[this.ovalue] : opt;
    },
    change(event) {
      this.$emit('update:modelValue', event.target.value);
    }
  }
};

const _hoisted_1$9 = {
  key: 0,
  class: "lsn-form__label"
};
const _hoisted_2$9 = ["list", "value", "placeholder"];
const _hoisted_3$7 = ["id"];
const _hoisted_4$4 = ["value"];
const _hoisted_5$1 = {
  key: 1,
  class: "lsn-form__error"
};
function render$b(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["lsn-form__wrapper", {
      'lsn-form__wrapper--error': $props.error
    }])
  }, [$props.label ? (openBlock(), createElementBlock("label", _hoisted_1$9, toDisplayString($props.label), 1)) : createCommentVNode("", true), createElementVNode("input", {
    list: $props.id,
    type: "text",
    class: "lsn-form__input",
    value: $props.modelValue,
    placeholder: $props.placeholder,
    onInput: _cache[0] || (_cache[0] = (...args) => $options.change && $options.change(...args))
  }, null, 40, _hoisted_2$9), createElementVNode("datalist", {
    id: $props.id,
    class: "lsn-form__select"
  }, [(openBlock(true), createElementBlock(Fragment, null, renderList($props.options, option => {
    return openBlock(), createElementBlock("option", {
      key: $options.optValue(option),
      value: $options.optValue(option)
    }, null, 8, _hoisted_4$4);
  }), 128))], 8, _hoisted_3$7), $props.error ? (openBlock(), createElementBlock("div", _hoisted_5$1, toDisplayString($options.errMsg), 1)) : createCommentVNode("", true)], 2);
}

script$b.render = render$b;

var script$a = {
  name: 'LsnIcon',
  props: {
    iname: {
      type: String,
      required: true
    }
  },
  computed: {
    href() {
      return require('@/assets/lsn-sprite.svg') + '#' + this.iname;
    }
  }
};

const _hoisted_1$8 = {
  class: "lsn-icon"
};
const _hoisted_2$8 = ["xlink:href"];
function render$a(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1$8, [createElementVNode("use", {
    "xlink:href": $options.href
  }, null, 8, _hoisted_2$8)]);
}

script$a.render = render$a;

var script$9 = {
  name: 'LsnInput',
  props: {
    modelValue: {
      type: [String, Number],
      default: null
    },
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    minlength: {
      type: Number,
      default: null
    },
    maxlength: {
      type: Number,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: [String, Array],
      default: null
    },
    tabindex: {
      type: Number,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  computed: {
    errMsg() {
      return Array.isArray(this.error) ? this.error[0] : this.error;
    }
  },
  methods: {
    change(event) {
      this.$emit('update:modelValue', event.target.value);
    },
    focus() {
      this.$nextTick(() => {
        this.$refs.input.focus();
      });
    }
  }
};

const _hoisted_1$7 = {
  key: 0,
  class: "lsn-form_label--required"
};
const _hoisted_2$7 = ["tabindex", "value", "placeholder", "minlength", "maxlength", "disabled"];
const _hoisted_3$6 = {
  key: 1,
  class: "lsn-form__error"
};
function render$9(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["lsn-form__wrapper", {
      'lsn-form__wrapper--error': $props.error
    }])
  }, [$props.label ? (openBlock(), createElementBlock("label", {
    key: 0,
    class: "lsn-form__label",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.focus && $options.focus(...args))
  }, [createTextVNode(toDisplayString($props.label) + " ", 1), $props.required ? (openBlock(), createElementBlock("span", _hoisted_1$7, "*")) : createCommentVNode("", true)])) : createCommentVNode("", true), createElementVNode("input", {
    ref: "input",
    type: "text",
    class: "lsn-form__input",
    tabindex: $props.tabindex,
    value: $props.modelValue,
    placeholder: $props.placeholder,
    minlength: $props.minlength,
    maxlength: $props.maxlength,
    disabled: $props.disabled,
    onInput: _cache[1] || (_cache[1] = (...args) => $options.change && $options.change(...args))
  }, null, 40, _hoisted_2$7), $props.error ? (openBlock(), createElementBlock("div", _hoisted_3$6, toDisplayString($options.errMsg), 1)) : createCommentVNode("", true)], 2);
}

script$9.render = render$9;

var script$8 = {
  name: 'LsnInputNumber',
  props: {
    modelValue: {
      validator(value) {
        return !isNaN(parseFloat(value));
      },
      default: null
    },
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    min: {
      type: Number,
      default: null
    },
    max: {
      type: Number,
      default: null
    },
    step: {
      type: Number,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: [String, Array],
      default: null
    },
    tabindex: {
      type: Number,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  computed: {
    errMsg() {
      return Array.isArray(this.error) ? this.error[0] : this.error;
    }
  },
  methods: {
    change(event) {
      this.$emit('update:modelValue', parseFloat(event.target.value));
    },
    focus() {
      this.$nextTick(() => {
        this.$refs.input.focus();
      });
    }
  }
};

const _hoisted_1$6 = {
  key: 0,
  class: "lsn-form_label--required"
};
const _hoisted_2$6 = ["tabindex", "min", "max", "step", "value", "placeholder", "disabled"];
const _hoisted_3$5 = {
  key: 1,
  class: "lsn-form__error"
};
function render$8(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["lsn-form__wrapper", {
      'lsn-form__wrapper--error': $props.error
    }])
  }, [$props.label ? (openBlock(), createElementBlock("label", {
    key: 0,
    class: "lsn-form__label",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.focus && $options.focus(...args))
  }, [createTextVNode(toDisplayString($props.label) + " ", 1), $props.required ? (openBlock(), createElementBlock("span", _hoisted_1$6, "*")) : createCommentVNode("", true)])) : createCommentVNode("", true), createElementVNode("input", {
    ref: "input",
    type: "number",
    class: "lsn-form__input",
    tabindex: $props.tabindex,
    min: $props.min,
    max: $props.max,
    step: $props.step,
    value: $props.modelValue,
    placeholder: $props.placeholder,
    disabled: $props.disabled,
    onInput: _cache[1] || (_cache[1] = (...args) => $options.change && $options.change(...args))
  }, null, 40, _hoisted_2$6), $props.error ? (openBlock(), createElementBlock("div", _hoisted_3$5, toDisplayString($options.errMsg), 1)) : createCommentVNode("", true)], 2);
}

script$8.render = render$8;

var script$7 = {
  name: 'LsnModal',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click-outside'],
  data() {
    return {
      isModalOpen: this.isOpen
    };
  },
  watch: {
    isOpen(isOpen) {
      this.isModalOpen = isOpen;
    }
  }
};

const _hoisted_1$5 = {
  key: 0,
  class: "lsn-modal__wrapper"
};
const _hoisted_2$5 = {
  class: "lsn-modal"
};
function render$7(_ctx, _cache, $props, $setup, $data, $options) {
  return $data.isModalOpen ? (openBlock(), createElementBlock("div", _hoisted_1$5, [createElementVNode("div", _hoisted_2$5, [renderSlot(_ctx.$slots, "default")]), createElementVNode("div", {
    class: "lsn-overlay",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('click-outside'))
  })])) : createCommentVNode("", true);
}

script$7.render = render$7;

var script$6 = {
  name: 'LsnRadioBox',
  props: {
    modelValue: {
      type: [String, Number, Boolean],
      default: null
    },
    label: {
      type: String,
      default: null
    },
    options: {
      type: Array,
      required: true
    },
    ovalue: {
      type: String,
      default: 'id'
    },
    olabel: {
      type: String,
      default: 'label'
    },
    error: {
      type: [String, Array],
      default: null
    },
    toggleable: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  computed: {
    errMsg() {
      return Array.isArray(this.error) ? this.error[0] : this.error;
    }
  },
  methods: {
    select(val) {
      if (val == this.modelValue && this.toggleable) {
        this.$emit('update:modelValue', null);
      } else {
        this.$emit('update:modelValue', val);
      }
    }
  }
};

const _hoisted_1$4 = {
  key: 0,
  class: "lsn-form__label"
};
const _hoisted_2$4 = {
  class: "lsn-form__radio-item-wrapper"
};
const _hoisted_3$4 = ["onClick"];
const _hoisted_4$3 = {
  key: 1,
  class: "lsn-form__error"
};
function render$6(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["lsn-form__wrapper", {
      'lsn-form__wrapper--error': $props.error
    }])
  }, [$props.label ? (openBlock(), createElementBlock("label", _hoisted_1$4, toDisplayString($props.label), 1)) : createCommentVNode("", true), createElementVNode("div", _hoisted_2$4, [(openBlock(true), createElementBlock(Fragment, null, renderList($props.options, option => {
    return openBlock(), createElementBlock("div", {
      key: option[$props.ovalue],
      class: normalizeClass(["lsn-form__radio-item", {
        'lsn-form__radio-item--selected': option[$props.ovalue] == $props.modelValue
      }]),
      onClick: $event => $options.select(option[$props.ovalue])
    }, toDisplayString(option[$props.olabel]), 11, _hoisted_3$4);
  }), 128))]), $props.error ? (openBlock(), createElementBlock("div", _hoisted_4$3, toDisplayString($options.errMsg), 1)) : createCommentVNode("", true)], 2);
}

script$6.render = render$6;

var script$5 = {
  name: 'LsnRadioList',
  props: {
    modelValue: {
      type: [String, Number],
      default: null
    },
    label: {
      type: String,
      default: null
    },
    name: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    ovalue: {
      type: String,
      default: 'id'
    },
    olabel: {
      type: String,
      default: 'label'
    },
    error: {
      type: [String, Array],
      default: null
    }
  },
  emits: ['update:modelValue'],
  computed: {
    errMsg() {
      return Array.isArray(this.error) ? this.error[0] : this.error;
    }
  },
  methods: {
    select(val) {
      this.$emit('update:modelValue', val);
    }
  }
};

const _hoisted_1$3 = {
  key: 0,
  class: "lsn-form__label"
};
const _hoisted_2$3 = {
  class: "lsn-form__radios"
};
const _hoisted_3$3 = ["name", "checked", "onChange"];
const _hoisted_4$2 = {
  key: 1,
  class: "lsn-form__error"
};
function render$5(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["lsn-form__wrapper", {
      'lsn-form__wrapper--error': $props.error
    }])
  }, [$props.label ? (openBlock(), createElementBlock("label", _hoisted_1$3, toDisplayString($props.label), 1)) : createCommentVNode("", true), createElementVNode("div", _hoisted_2$3, [(openBlock(true), createElementBlock(Fragment, null, renderList($props.options, option => {
    return openBlock(), createElementBlock("label", {
      key: option[$props.ovalue],
      class: "lsn-form__radio-label"
    }, [createElementVNode("input", {
      type: "radio",
      class: "lsn-form__radio",
      name: $props.name,
      checked: $props.modelValue == option[$props.ovalue],
      onChange: $event => $options.select(option[$props.ovalue])
    }, null, 40, _hoisted_3$3), createTextVNode(" " + toDisplayString(option[$props.olabel]), 1)]);
  }), 128))]), $props.error ? (openBlock(), createElementBlock("div", _hoisted_4$2, toDisplayString($options.errMsg), 1)) : createCommentVNode("", true)], 2);
}

script$5.render = render$5;

var script$4 = {
  name: 'LsnSelect',
  props: {
    modelValue: {
      type: [String, Number],
      default: null
    },
    label: {
      type: String,
      default: null
    },
    options: {
      type: Array,
      required: true
    },
    ovalue: {
      type: String,
      default: 'id'
    },
    olabel: {
      type: String,
      default: 'label'
    },
    error: {
      type: [String, Array],
      default: null
    },
    tabindex: {
      type: Number,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  computed: {
    errMsg() {
      return Array.isArray(this.error) ? this.error[0] : this.error;
    }
  },
  methods: {
    optLabel(opt) {
      if (typeof opt !== 'object') {
        return opt;
      }
      return opt?.[this.olabel] ?? opt;
    },
    optValue(opt) {
      if (typeof opt !== 'object') {
        return opt;
      }
      return opt?.[this.ovalue] ?? opt;
    },
    change(event) {
      this.$emit('update:modelValue', event.target.value);
    },
    focus() {
      this.$nextTick(() => {
        this.$refs.input.focus();
      });
    }
  }
};

const _hoisted_1$2 = {
  key: 0,
  class: "lsn-form_label--required"
};
const _hoisted_2$2 = ["value", "tabindex"];
const _hoisted_3$2 = ["value"];
const _hoisted_4$1 = {
  key: 1,
  class: "lsn-form__error"
};
function render$4(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["lsn-form__wrapper", {
      'lsn-form__wrapper--error': $props.error
    }])
  }, [$props.label ? (openBlock(), createElementBlock("label", {
    key: 0,
    class: "lsn-form__label",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.focus && $options.focus(...args))
  }, [createTextVNode(toDisplayString($props.label) + " ", 1), $props.required ? (openBlock(), createElementBlock("span", _hoisted_1$2, "*")) : createCommentVNode("", true)])) : createCommentVNode("", true), createElementVNode("select", {
    ref: "input",
    class: "lsn-form__select",
    value: $props.modelValue,
    tabindex: $props.tabindex,
    onChange: _cache[1] || (_cache[1] = (...args) => $options.change && $options.change(...args))
  }, [(openBlock(true), createElementBlock(Fragment, null, renderList($props.options, option => {
    return openBlock(), createElementBlock("option", {
      key: $options.optValue(option),
      value: $options.optValue(option)
    }, toDisplayString($options.optLabel(option)), 9, _hoisted_3$2);
  }), 128))], 40, _hoisted_2$2), $props.error ? (openBlock(), createElementBlock("div", _hoisted_4$1, toDisplayString($options.errMsg), 1)) : createCommentVNode("", true)], 2);
}

script$4.render = render$4;

var script$3 = {
  name: 'LsnSider',
  props: {
    isOpen: {
      type: Boolean,
      required: false,
      default: true
    },
    side: {
      type: String,
      default: 'right'
    }
  },
  data() {
    return {
      isOpen_: this.isOpen
    };
  },
  computed: {
    isLeft() {
      return this.side.toLowerCase() === 'left';
    },
    isright() {
      return !this.isLeft;
    },
    transitionName() {
      if (this.isLeft) {
        return 'slide-left';
      }
      return 'slide-right';
    }
  },
  watch: {
    isOpen(isOpen) {
      this.isOpen_ = isOpen;
    }
  }
};

function render$3(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(Transition, {
    name: $options.transitionName
  }, {
    default: withCtx(() => [$data.isOpen_ ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: normalizeClass(["lsn-sider", {
        'lsn-sider--left': $options.isLeft
      }])
    }, [renderSlot(_ctx.$slots, "default")], 2)) : createCommentVNode("", true)]),
    _: 3
  }, 8, ["name"]);
}

script$3.render = render$3;

var script$2 = {
  name: 'LsnSlide',
  props: {
    width: {
      type: Number,
      default: 240
    },
    text: {
      type: String,
      default: null
    }
  },
  emits: ['slide'],
  data() {
    return {
      isMoving: false,
      isPassing: false,
      x: 0
    };
  },
  methods: {
    dragStart: function (e) {
      if (!this.isPassing) {
        this.isMoving = true;
        var handler = this.$refs.handler;
        this.x = (e.pageX || e.touches[0].pageX) - parseInt(handler.style.left.replace('px', ''), 10);
      }
    },
    dragMoving: function (e) {
      if (this.isMoving && !this.isPassing) {
        var _x = (e.pageX || e.touches[0].pageX) - this.x;
        var handler = this.$refs.handler;
        if (_x > 0 && _x <= this.width - 60) {
          handler.style.left = _x + 'px';
        } else if (_x > this.width - 60) {
          handler.style.left = this.width - 40 + 'px';
          this.passVerify();
        }
      }
    },
    dragFinish: function (e) {
      if (this.isMoving && !this.isPassing) {
        var _x = (e.pageX || e.changedTouches[0].pageX) - this.x;
        if (_x < this.width - 40) {
          this.$refs.handler.style.left = '2px';
        }
        this.isMoving = false;
      }
    },
    passVerify: function () {
      this.isPassing = true;
      this.isMoving = false;
      this.$emit('slide');
    }
  }
};

function render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: "lsn-slide",
    style: normalizeStyle({
      'width': $props.width + 'px'
    }),
    onMousemove: _cache[2] || (_cache[2] = (...args) => $options.dragMoving && $options.dragMoving(...args)),
    onMouseup: _cache[3] || (_cache[3] = (...args) => $options.dragFinish && $options.dragFinish(...args)),
    onTouchmove: _cache[4] || (_cache[4] = (...args) => $options.dragMoving && $options.dragMoving(...args)),
    onTouchend: _cache[5] || (_cache[5] = (...args) => $options.dragFinish && $options.dragFinish(...args))
  }, [createElementVNode("div", {
    ref: "text",
    class: "lsn-slide__text"
  }, toDisplayString($props.text), 513), createElementVNode("div", {
    ref: "handler",
    class: "lsn-slide__handler",
    style: {
      "left": "2px"
    },
    onMousedown: _cache[0] || (_cache[0] = (...args) => $options.dragStart && $options.dragStart(...args)),
    onTouchstart: _cache[1] || (_cache[1] = (...args) => $options.dragStart && $options.dragStart(...args))
  }, null, 544)], 36);
}

script$2.render = render$2;

var script$1 = {
  name: 'LsnSwitch',
  props: {
    modelValue: {
      type: [Boolean, Number],
      default: null
    },
    label: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: [String, Array],
      default: null
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  computed: {
    errMsg() {
      return Array.isArray(this.error) ? this.error[0] : this.error;
    },
    id() {
      return 'toggle' + this.random(1000000, 9999999);
    }
  },
  methods: {
    change(event) {
      if (this.disabled) {
        return;
      }
      this.$emit('update:modelValue', event.target.checked);
    },
    random(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
  }
};

const _hoisted_1$1 = ["for"];
const _hoisted_2$1 = {
  key: 0,
  class: "lsn-form_label--required"
};
const _hoisted_3$1 = {
  class: "lsn-form__switch-wrapper"
};
const _hoisted_4 = ["id", "checked", "disabled"];
const _hoisted_5 = ["for"];
const _hoisted_6 = {
  key: 1,
  class: "lsn-form__error"
};
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["lsn-form__wrapper", {
      'lsn-form__wrapper--error': $props.error
    }])
  }, [$props.label ? (openBlock(), createElementBlock("label", {
    key: 0,
    for: $options.id,
    class: "lsn-form__label lsn-form__label--inline"
  }, [createTextVNode(toDisplayString($props.label) + " ", 1), $props.required ? (openBlock(), createElementBlock("span", _hoisted_2$1, "*")) : createCommentVNode("", true)], 8, _hoisted_1$1)) : createCommentVNode("", true), createElementVNode("div", _hoisted_3$1, [createElementVNode("input", {
    id: $options.id,
    type: "checkbox",
    checked: $props.modelValue,
    disabled: $props.disabled,
    class: "lsn-form__switch-toggle-checkbox",
    onChange: _cache[0] || (_cache[0] = (...args) => $options.change && $options.change(...args))
  }, null, 40, _hoisted_4), createElementVNode("label", {
    for: $options.id,
    class: "lsn-form__switch-toggle-label"
  }, null, 8, _hoisted_5)]), $props.error ? (openBlock(), createElementBlock("div", _hoisted_6, toDisplayString($options.errMsg), 1)) : createCommentVNode("", true)], 2);
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$1 = "\n.lsn-form__error[data-v-38096760]\n{\n    padding-top: 0;\n}\n";
styleInject(css_248z$1);

script$1.render = render$1;
script$1.__scopeId = "data-v-38096760";

var script = {
  name: 'LsnTextarea',
  props: {
    modelValue: {
      type: [String, Number],
      default: null
    },
    label: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: [String, Array],
      default: null
    },
    tabindex: {
      type: Number,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  computed: {
    errMsg() {
      return Array.isArray(this.error) ? this.error[0] : this.error;
    }
  },
  methods: {
    change(event) {
      this.$emit('update:modelValue', event.target.value);
    },
    focus() {
      this.$nextTick(() => {
        this.$refs.input.focus();
      });
    }
  }
};

const _hoisted_1 = {
  key: 0,
  class: "lsn-form_label--required"
};
const _hoisted_2 = ["value", "tabindex", "disabled"];
const _hoisted_3 = {
  key: 1,
  class: "lsn-form__error"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["lsn-form__wrapper", {
      'lsn-form__wrapper--error': $props.error
    }])
  }, [$props.label ? (openBlock(), createElementBlock("label", {
    key: 0,
    class: "lsn-form__label",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.focus && $options.focus(...args))
  }, [createTextVNode(toDisplayString($props.label) + " ", 1), $props.required ? (openBlock(), createElementBlock("span", _hoisted_1, "*")) : createCommentVNode("", true)])) : createCommentVNode("", true), createElementVNode("textarea", {
    ref: "input",
    class: "lsn-form__textarea",
    value: $props.modelValue,
    tabindex: $props.tabindex,
    disabled: $props.disabled,
    onInput: _cache[1] || (_cache[1] = (...args) => $options.change && $options.change(...args))
  }, null, 40, _hoisted_2), $props.error ? (openBlock(), createElementBlock("div", _hoisted_3, toDisplayString($options.errMsg), 1)) : createCommentVNode("", true)], 2);
}

var css_248z = "\n.lsn-form__error[data-v-7da96218]\n{\n    padding-top: 0;\n}\n";
styleInject(css_248z);

script.render = render;
script.__scopeId = "data-v-7da96218";

var components = /*#__PURE__*/Object.freeze({
    __proto__: null,
    LsnCheckboxBox: script$d,
    LsnCheckboxList: script$c,
    LsnClickOutside: LsnClickOutside,
    LsnDataList: script$b,
    LsnIcon: script$a,
    LsnInput: script$9,
    LsnInputNumber: script$8,
    LsnModal: script$7,
    LsnRadioBox: script$6,
    LsnRadioList: script$5,
    LsnSelect: script$4,
    LsnSider: script$3,
    LsnSlide: script$2,
    LsnSwitch: script$1,
    LsnTextarea: script
});

// Import vue components

// install function executed by Vue.use()
const install = function installVueLausanne(app) {
  Object.entries(components).forEach(([componentName, component]) => {
    app.component(componentName, component);
  });
};

export { script$d as LsnCheckboxBox, script$c as LsnCheckboxList, LsnClickOutside, script$b as LsnDataList, script$a as LsnIcon, script$9 as LsnInput, script$8 as LsnInputNumber, script$7 as LsnModal, script$6 as LsnRadioBox, script$5 as LsnRadioList, script$4 as LsnSelect, script$3 as LsnSider, script$2 as LsnSlide, script$1 as LsnSwitch, script as LsnTextarea, install as default };
